import React from 'react';
import contact from '../../../assets/img/getin.png';
import { Divider, Input } from 'antd';
import {
  Form,
  Row,
  Col,
  Button,
} from 'antd';
import InputMask from "react-input-mask";



class EAD extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isloding: false, States: []
    }
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let phone = [];
        phone.push({
          phonE_CODE: values.phonE_CODEh,
          phonE_NUMBER: values.phonE_NUMBERh,
          phonE_EXTENSION: values.phonE_EXTENSIONh,
        });
        phone.push({
          phonE_CODE: values.phonE_CODEb,
          phonE_NUMBER: values.phonE_NUMBERb,
          phonE_EXTENSION: values.phonE_EXTENSIONb,
        });
        if (values.phonE_CODEf)
          phone.push({
            phonE_CODE: values.phonE_CODEf,
            phonE_NUMBER: values.phonE_NUMBERf,
          });
        this.props.submitHandler({ phone: phone });
      }
    });
  }
  componentDidMount = () => {
    const { setFieldsValue } = this.props.form;
    const { predata } = this.props;

    if (this.props.niprappoinment && this.props.niprappoinment.phone) {
      let { phone } = this.props.niprappoinment;
      setTimeout(() => {
        setFieldsValue({
          phonE_CODEh: phone[0].phonE_CODE,
          phonE_NUMBERh: phone[0].phonE_NUMBER,
          phonE_EXTENSIONh: phone[0].phonE_EXTENSION,
          phonE_CODEb: phone[1].phonE_CODE,
          phonE_NUMBERb: phone[1].phonE_NUMBER,
          phonE_EXTENSIONb: phone[1].phonE_EXTENSION,
          phonE_CODEf: phone[2].phonE_CODE,
          phonE_NUMBERf: phone[2].phonE_NUMBER,
        })
      }, 100);
    }else{
      setFieldsValue({
        phonE_NUMBERh:predata&&predata.phone,
        phonE_NUMBERb:predata&&predata.phone,
      })
    }
  }
  render() {
    const { getFieldDecorator } = this.props.form;

    return (

      <div ><Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>

        <Row>
          <Col md={10} sm={24}>
            <img className='ant-login-image' alt="example" style={{ width: '450px', margin: '0', height: 450 }} src={contact} />
          </Col>

          <Col md={14} sm={24}>

            <div style={{ marginLeft: "15px", marginTop: "16px", marginBottom: "-16px" }}>
              <p style={{ marginBottom: "10px" }}>Home Phone Number</p>
              <Divider style={{ marginTop: "6px" }}></Divider></div>
            <Row>
              <Col md={12} sm={24}>
                <Form.Item>
                  {getFieldDecorator('phonE_CODEh', {
                    initialValue: '01'
                  })(
                    <Input hidden />
                  )}
                </Form.Item>
                <Form.Item>

                  <fieldset className="mi_input_pop" >
                    <legend className="legend-font"> Number *</legend>
                    {getFieldDecorator('phonE_NUMBERh', {
                      rules: [{ required: true, message: 'Please enter home phone number.' },
                      {
                        pattern: /^((\+0?1\s)?)\(?\d{3}\)?[\s.\s]\d{3}[\s.-]\d{4}$/,
                        message: 'phone number is invalid'
                      }
                      ],
                    })(
                      <InputMask mask="+1 (999) 999-9999" autoComplete={"nope"} type="text" className="ant-input mi_input" placeholder="Enter Home Phone Number" />
                    )
                    }
                  </fieldset>
                </Form.Item></Col>
              <Col md={12} sm={24}>
                <Form.Item>
                  <fieldset className="mi_input_pop" >
                    <legend className="legend-font"> Ext.</legend>
                    {getFieldDecorator('phonE_EXTENSIONh', {
                      rules: [
                        {
                          max: 10,
                          message: "Ext is  must be at most 10 characters"
                        }
                      ],
                    })(
                      <Input maxLength={10} autoComplete={"nope"} type="number" className="ant-input mi_input" placeholder="Enter Ext " />
                    )
                    }
                  </fieldset>
                </Form.Item></Col></Row>

            < div style={{ marginLeft: "15px", marginTop: "16px", marginBottom: "-16px" }}>
              <p>Business Phone Number</p>
              <Divider style={{ marginTop: "6px" }}></Divider></div>

            <Row>
              <Col md={12} sm={24}>
                <Form.Item>
                  {getFieldDecorator('phonE_CODEb', {
                    initialValue: '02'
                  })(
                    <Input hidden />
                  )}
                </Form.Item>
                <Form.Item >

                  <fieldset className="mi_input_pop" >
                    <legend className="legend-font"> Number *</legend>
                    {getFieldDecorator('phonE_NUMBERb', {
                      rules: [{ required: true, message: 'Please enter Business  phone number.' },
                      {
                        pattern: /^((\+0?1\s)?)\(?\d{3}\)?[\s.\s]\d{3}[\s.-]\d{4}$/,
                        message: "Invalid Phone Number",
                      }
                      ],
                    })(
                      <InputMask mask="+1 (999) 999-9999" autoComplete={"nope"} type="text" className="ant-input mi_input" placeholder="Enter Business  Phone Number" />
                    )
                    }
                  </fieldset>
                </Form.Item></Col>
              <Col md={12} sm={24}>
                <Form.Item>
                  <fieldset className="mi_input_pop" >
                    <legend className="legend-font"> Ext.</legend>
                    {getFieldDecorator('phonE_EXTENSIONb', {
                      rules: [
                        {
                          max: 10,
                          message: "Ext is  must be at most 10 characters"
                        }
                      ],
                    })(
                      <Input autoComplete={"nope"} maxLength={10} type="number" className="ant-input mi_input" placeholder="Enter Ext " />
                    )
                    }
                  </fieldset>
                </Form.Item></Col>
            </Row>
            <div style={{ marginLeft: "15px", marginTop: "16px", marginBottom: "-16px" }}>
              <p>Fax Number</p>
              <Divider ></Divider></div>
            <Row>
              <Col md={12} sm={24}>
                <Form.Item>
                  {getFieldDecorator('phonE_CODEf', {
                    initialValue: '05'
                  })(
                    <Input hidden />
                  )}
                </Form.Item>
                <Form.Item>

                  <fieldset className="mi_input_pop" >
                    <legend className="legend-font"> Fax *</legend>
                    {getFieldDecorator('phonE_NUMBERf', {
                      initialValue: "+1 (999) 999-9999",
                      rules: [{ required: true, message: 'Please enter Fax number.' },
                      {
                        pattern: /^((\+0?1\s)?)\(?\d{3}\)?[\s.\s]\d{3}[\s.-]\d{4}$/,
                        message: 'Fax number is invalid'
                      }
                      ]
                    })(
                      <InputMask mask="+1 (999) 999-9999" autoComplete={"nope"} maxLength={20} type="text" className="ant-input mi_input" placeholder="Enter Fax Phone Number" />
                    )
                    }
                  </fieldset>
                </Form.Item></Col>
            </Row>


          </Col>
        </Row>

        <div className="collapsepanel-footer">
          <Button className=" ant-btn mi_button_right" style={{ float: "left", marginTop: "-20px", marginLeft: "-11px" }} onClick={() => this.props.back("exp")}> Back</Button>
          <Button htmlType='submit' className=" ant-btn-primary" style={{ float: "right", marginTop: "-20px", marginRight: "-11px" }}> Next</Button>
        </div>

      </Form>

      </div>

    )
  }

}
const NiprContact = Form.create()(EAD);


export default NiprContact;
